import { asGrafanaStat } from '../../../../../shared/stats/asGrafanaStat';

const TOAST = 'toast';

function notificationToastEvent(eventName) {
    return asGrafanaStat(TOAST, eventName);
}

export const eventTypes = {
    NOTIFICATION_TOAST_EMITTED: notificationToastEvent('emitted'),
    NOTIFICATION_TOAST_CLICKED: notificationToastEvent('clicked'),
    NOTIFICATION_TOAST_DISMISSED: notificationToastEvent('dismissed'),
};
